import { render } from "./featured.vue?vue&type=template&id=1ce8f13e"
import script from "./featured.vue?vue&type=script&lang=js"
export * from "./featured.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__